import { useAuth } from '../stores/auth';

/** useCan('workOrders.assign') — render-time gate only; the API enforces the real rule. */
export function useCan(permission: string): boolean {
  return useAuth((s) => s.can(permission));
}

export function useCanPage(page: string): boolean {
  return useAuth((s) => s.canAccessPage(page));
}
